import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { FIELD__ml_asset_lora } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD__ml_asset_lora';
import { useState } from 'react';
import { HOOK__ml_asset_name_and_version } from '../../_hooks/HOOK__ml_asset_name_and_version';
import { G_BUTTON__field_use_as_grid2d_column } from '../_base/_buttons/G_BUTTON__field_use_as_grid2d_column';
import { G_BUTTON__field_use_as_grid2d_row } from '../_base/_buttons/G_BUTTON__field_use_as_grid2d_row';
import { G_UI_FIELD__info } from '../_base/G_UI_FIELD__info';
import { G_UI_FIELD__wrapper } from '../_base/G_UI_FIELD__wrapper';
import { G_BUTTON__field_number_slider_step_change } from '../primitive_number/G_BUTTON__field_number_slider_step_change';
import { G_UI_FIELD_PRIMITIVE__number } from '../primitive_number/G_UI_FIELD_PRIMITIVE__number';
import { G_BUTTON__ml_asset_lora_change_status } from './_buttons/G_BUTTON__ml_asset_lora_change_status';

interface PROPS {
  field: FIELD__ml_asset_lora;
}

export function G_UI_FIELD__ml_asset_lora_list_item({ field }: PROPS) {
  const [is_mouse_hovered, set_is_mouse_hovered] = useState(false);

  let { name, version } = HOOK__ml_asset_name_and_version({ hash: field.model.get_value() });

  if (version == ENUM__string_id_empty.ML_ASSET_VERSION) version = '';

  /*
   *
   */

  /*
   *
   */

  function render_title_name() {
    return (
      <div className={`flex items-center justify-start gap-1 px-1 w-full  py-1  text-xs text-left text-bar-foreground`}>
        <G_UI_FIELD__info {...{ field }} />
        <span className="flex-1 h-full truncate ">
          {name} {version}
        </span>
      </div>
    );
  }

  function render_title_actions() {
    return (
      <div className={`flex items-center justify-between px-1 w-full   text-xs text-left text-bar-foreground `}>
        <G_UI_FIELD__info {...{ field }} />
        <G_BUTTON__field_use_as_grid2d_column field={field.weight} />
        <G_BUTTON__field_use_as_grid2d_row field={field.weight} />
        <G_BUTTON__field_number_slider_step_change field={field.weight} />
        <G_BUTTON__ml_asset_lora_change_status field={field} />
      </div>
    );
  }
  /*
   *
   */

  return (
    <G_UI_FIELD__wrapper className={'overflow-hidden'} {...{ field }}>
      <div onMouseEnter={() => set_is_mouse_hovered(true)} onMouseLeave={() => set_is_mouse_hovered(false)} className={`flex flex-col w-full`}>
        {is_mouse_hovered && render_title_actions()}
        {!is_mouse_hovered && render_title_name()}
        <G_UI_FIELD_PRIMITIVE__number field={field.weight} without_header />
      </div>
    </G_UI_FIELD__wrapper>
  );
}
